/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_Works__Callout_TitleInputs */

const en_how_it_works__callout_title = /** @type {(inputs: How_It_Works__Callout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The BidBattles Concept`)
};

/**
* | output |
* | --- |
* | "The BidBattles Concept" |
*
* @param {How_It_Works__Callout_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const how_it_works__callout_title = /** @type {((inputs?: How_It_Works__Callout_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_Works__Callout_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_how_it_works__callout_title(inputs)
});